import { BundleProduct, Product } from "../lib/models/Products";

import Ampersandist from "./ampersandist";
import Felicette from "./felicette";
import Monochromic from "./monochromic";
import Nebulith from "./nebulith";
import { ReactNode } from "react";

interface StyleGroup {
  name: string;
  fontStyles: Product[];
}

interface SpecimenRow {
  fontName: string;
  fontFamily: string;
  fontText: string;
  group: string;
}

interface FontSettings {
  name: string;
  subtitle: string;
  accentColor: string;
  secondaryAccentColor: string;
  fineTextColor: string;
  skipMultiplyOnMainPage?: boolean;
  defaultStyle: string;
  variableCssName?: string;
  styleGroups: StyleGroup[];
  stylePurchaseBundles: BundleProduct[];
  specimenRows: SpecimenRow[];
  textFontFamily: string;
  headerFontFamily: string;
  info: {
    description: ReactNode;
    languagesSupported: string;
    collection: string;
    designers: string;
    release: string;
    numWeights: number;
    numStyles: number;
    version: string;
    fileFormats: string;
  };
}

export const FONT_SETTINGS: { [name: string]: FontSettings } = {
  felicette: Felicette,
  monochromic: Monochromic,
  ampersandist: Ampersandist,
  nebulith: Nebulith,
};

export const requireFont = (context) => {
  let fontName = context.query.name.replaceAll(".html", "");

  if (!FONT_SETTINGS[fontName]) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      fontName,
    },
  };
};
